module.exports = __webpack_public_path__ + "static/lifewheel-yellow-d008d3c8dc2d1475c425dc4932a08c49.png";